import { CreditCardType } from '@anm/api/modules/subscription';
import { FC } from 'react';
import styled from 'styled-components';

import CardBlock from '../CardBlock';
import DotsCardNumber from '../DotsCardNumber';

export type CardDetailsInlineProps = {
  last4: string;
  cardType: CreditCardType;
  className?: string;
};

const CardDetailsInlineWrapper = styled.div`
  display: flex;
  flex: 0 1 255px;
  ${CardBlock} {
    margin: 0;
  }
`;

const CardDetailsInline: FC<CardDetailsInlineProps> = ({
  cardType,
  last4,
  className
}) => (
  <CardDetailsInlineWrapper className={className}>
    <CardBlock cardType={cardType} />
    <DotsCardNumber last4={last4} />
  </CardDetailsInlineWrapper>
);

export default CardDetailsInline;
